import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import StopSubSequenceNodePreview from "../../features/sequence/node_previews/StopSubSequenceNodePreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { Actor } from "../Actor";
import Take from "../Take";
import Interaction, { InteractionType } from "./Interaction";
import { compactSearchableStrings } from "./SearchableInteractionValues";

export interface IStopSubSequence extends Interaction {
  nodeToPlay: string;
}

export const stopSubSequenceInteraction = (): InteractionFactoryEntity => {
  const create = (getKeys: (amount: number) => string[]): IStopSubSequence => {
    return {
      id: GetNewGuid(),
      name: "Stop Sub Sequence",
      type: InteractionType.StopSubSequence,
      nodeToPlay: "",
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction,
  ): IStopSubSequence => {
    return interaction as IStopSubSequence;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[],
  ): IStopSubSequence => {
    const original = interaction as IStopSubSequence;

    return {
      ...original,
      id: GetNewGuid(),
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string,
  ): string[] => {
    return [];
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string,
    ) => SearchResultData[],
  ): SearchResultData[] => {
    const converted = interaction as IStopSubSequence;
    return getMatchingResults(
      compactSearchableStrings(interaction.name, converted.nodeToPlay),
      takeName,
      interaction,
      "Stop Sub Sequence"
    );
  };

  const validateErrors = (
    interaction: Interaction,
    parentTake: Take,
    currentTake: Take,
    actorPresets: Actor[],
  ): string[] => {
    return [];
  };

  return {
    View: <></>,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <StopSubSequenceNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateErrors,
    FilterType: "Stop Sub Sequence",
  };
};
